export default __webpack_public_path__ + "static/media/5.f07a3a5e.jpg";